import { Redirect } from "wouter";

export default function DisabledAcademyRuntime() {
  return <Redirect to="/programmes/teen-ai-builders-academy" />;
}